export enum TempCheckFor {
  Batch = 'Batch',
  Counter = 'Counter',
  FirstAir = 'FirstAir',
  Regular = 'Regular',
  CompletedAM = 'CompletedAM',
  CompletedToday = 'CompletedToday',
}
